import LocalizedMessage from './LocalizedMessage';

export default LocalizedMessage;
